export default __webpack_public_path__ + "static/media/grey_undo.b6b85736.svg";